import React, { useContext } from "react";
import classNames from "classnames";

import { getScreenId } from "utils/getScreenId";

import { MapContext } from "../Map/Map";

import MoveDownButton from "../MoveDownButton/MoveDownButton";

import styles from "./Footer.module.scss";
import { useTranslation } from "react-i18next";

interface Props {
  controlsAlwaysLow: boolean;
  footerRef: React.RefObject<HTMLDivElement>;
  shareToMobileComponent?: React.ReactNode;
  langSelectComponent?: React.ReactNode;
}

export default function Footer({
  footerRef,
  controlsAlwaysLow,
  shareToMobileComponent,
  langSelectComponent,
}: Props) {
  const { controlTheme } = useContext(MapContext);
  const screenId = getScreenId();
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.gradientWrapper}>
        <div className={styles.gradient} />
        <div className={styles.colourBlock} />
      </div>
      <footer className={styles.container} data-qa="footer">
        <div className={styles.contentContainer} ref={footerRef}>
          <div className={styles.content}>
            <div
              className={classNames(styles.buttons, styles.showLowerControls)}
            >
              {shareToMobileComponent}
              {langSelectComponent}
              {!controlsAlwaysLow && (
                <MoveDownButton
                  color="black"
                  classNames={styles.moveControlsButton}
                  outlined={controlTheme === "light"}
                />
              )}
            </div>
            <div className={styles.attribution}>
              <span>&copy; {t("footer.company")}</span>
              <span>&copy; {t("footer.attribution")}</span>
              <span>{screenId}</span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
